const PHONE = /^(\+[1-9]{1}[0-9]{7,12}|)$/

export default function () {
  return (value) => {
    if (!value) return
    if (typeof value === 'string' && !value.match(PHONE)) {
      throw new Error(
        JSON.stringify({ id: 'reformulate.validate_phone_invalid' }),
      )
    }
  }
}
